module.exports = __webpack_public_path__ + "static/media/curves_canela.6864dbf0.jpg";